import type { ParentOrderTarget } from '@mathflat/domain/PodCart'
import type { ParentOrderCreation } from '@mathflat/domain/PodOrder'
import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

export class CartItemStudent {
  _id: string
  name: string
  studentId: string
  printingUserName: string
  parentPhoneNumber: string

  constructor({
    _id,
    name,
    studentId,
    printingUserName,
    parentPhoneNumber,
  }: Partial<CartItemStudent> = {}) {
    makeAutoObservable(this)

    this._id = _id ?? uuidv4()
    this.name = name ?? ''
    this.studentId = studentId ?? ''
    this.printingUserName = printingUserName ?? name ?? ''
    this.parentPhoneNumber = parentPhoneNumber ?? ''
  }

  toParentOrders(): ParentOrderTarget {
    return {
      studentId: this.studentId,
      parentPhoneNumber: this.parentPhoneNumber,
      studentName: this.name,
      printingUserName: this.printingUserName,
    }
  }

  get toParentOrderParams(): ParentOrderCreation['parentOrderItems'][number]['parentOrders'][number] {
    return {
      parentPhoneNumber: this.parentPhoneNumber,
      studentName: this.name,
      printingUserName: this.printingUserName,
    }
  }
}
